// Authentication service using business service
import { login as businessLogin, getBusinessId as businessGetId, clearToken as businessClearToken, isAuthenticated as businessIsAuthenticated } from './business';

// Export the functions from business service, with renamed imports to avoid conflicts
export const login = businessLogin;
export const getBusinessId = businessGetId;
export const clearToken = businessClearToken;
export const isAuthenticated = businessIsAuthenticated;

// Constants for storage keys
const TOKEN_KEY = 'green_pioneers_token';
const BUSINESS_ID_KEY = 'green_pioneers_business_id';

/**
 * Store token and business ID in session storage
 */
export const storeToken = (token: string, businessId: string): void => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(BUSINESS_ID_KEY, businessId);
};

/**
 * Get token from session storage
 */
export const getToken = (): string | null => {
  return sessionStorage.getItem(TOKEN_KEY);
};

// The following functions are commented out as they conflict with the imported ones
// Uncomment if you need to switch back to session storage based auth

/*
 * Get business ID from session storage
 */
// export const getBusinessId = (): string | null => {
//   return sessionStorage.getItem(BUSINESS_ID_KEY);
// };

/*
 * Clear token and business ID from session storage
 */
// export const clearToken = (): void => {
//   sessionStorage.removeItem(TOKEN_KEY);
//   sessionStorage.removeItem(BUSINESS_ID_KEY);
// };

/*
 * Check if user is authenticated
 */
// export const isAuthenticated = (): boolean => {
//   return !!getToken() && !!getBusinessId();
// }; 